interface FormatIarRunNumberParams {
  runId: string;
  runDate?: string | null;
}

const toDateStamp = (runDate?: string | null): string | null => {
  if (!runDate) {
    return null;
  }

  const parsed = new Date(runDate);
  if (Number.isNaN(parsed.getTime())) {
    return null;
  }

  const year = parsed.getUTCFullYear();
  const month = String(parsed.getUTCMonth() + 1).padStart(2, '0');
  const day = String(parsed.getUTCDate()).padStart(2, '0');
  return `${year}${month}${day}`;
};

export const formatIarRunNumber = ({ runId, runDate }: FormatIarRunNumberParams): string => {
  const compactRunId = runId.replace(/-/g, '').toUpperCase();
  const shortId = compactRunId.slice(0, 6);
  const dateStamp = toDateStamp(runDate);

  if (dateStamp && shortId) {
    return `IAR-${dateStamp}-${shortId}`;
  }

  if (shortId) {
    return `IAR-${shortId}`;
  }

  return 'Unknown';
};
